var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "flex items-center justify-center shadow-lg rounded-lg overflow-hidden pointer-events-auto",
      class: {
        "bg-gray-800 text-white": !_vm.options.error,
        "bg-red-200 text-red-700 font-medium": _vm.options.error
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "flex items-center justify-center p-4 rounded-l-lg",
          class: { "border border-r-0 border-red-300": _vm.options.error }
        },
        [
          _vm.options.loading
            ? _c("LoadingCircle", { staticClass: "mr-3 w-6 h-6" })
            : _vm._e(),
          _c("MarkdownContent", { attrs: { content: _vm.message } })
        ],
        1
      ),
      _vm.options.action
        ? _c(
            "button",
            {
              staticClass:
                "relative flex p-4 font-bold uppercase text-sm group self-stretch items-center",
              class: { "bg-red-500 text-white": _vm.options.error },
              attrs: { type: "button" },
              on: { click: _vm.clickAction }
            },
            [
              _c("div", {
                staticClass:
                  "absolute inset-0 opacity-15 bg-black group-hover:opacity-30"
              }),
              _c("span", { staticClass: "z-10" }, [
                _vm._v(_vm._s(_vm.options.action.text))
              ])
            ]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }